
export const FONT_SIZE_TITLE = 24;
export const FONT_SIZE_SUBTITLE = 18;
export const FONT_SIZE_NORMAL = 11;

export const COL_WIDTH_LEFT = 15;

export const COL_WIDTH_TBL_MIN_REPORT = 45; // Minimum column width for report tables, to ensure readability of wrapped text (e.g. in headers)

export const ROW_HEIGHT_TBL_HEADER_DEFAULT = 15;
export const ROW_HEIGHT_TBL_HEADER_DOUBLE = 30; // Used when header text is wrapped

export const COLOR_HARLEY_ORANGE = "#FF6600";    
export const COLOR_HARLEY_BLACK = "#000000"; // lol just black

export const COLOR_HEADER_FILL_STANDARD = COLOR_HARLEY_ORANGE; // "#689bd8"; // "#0b1b2f";
export const COLOR_HEADER_FONT_STANDARD = "#FFFFFF";

export const COLOR_DASH_ORANGE_HEADER = COLOR_HARLEY_ORANGE;
export const COLOR_DASH_LT_BLUE_HEADER = "#538DD5";
export const COLOR_DASH_GREEN_HEADER = "#948A54";
export const COLOR_RADAR_HOME_THEME = "#18049e";

export const COLOR_COND_FORMAT_ATTENTION = "#d55f4b";
export const COLOR_COND_FORMAT_POSITIVE = "#58e4a5";
export const COLOR_COND_FORMAT_NEGATIVE = "#fa3535";

// export const COLOR_DASH_BG = "#ffb27f";
export const COLOR_DASH_BG = "#ffe4d2";

export const COLOR_HEADER_HOME = COLOR_HARLEY_ORANGE;
export const COLOR_HEADER_VS_ENTRY = "#18049e";
export const COLOR_HEADER_VS_MGR_REPORT = "#9e047f";
export const COLOR_HEADER_VS_GP_DETAILS = "#4f825b";
export const COLOR_HEADER_VS_LEADERBOARD = "#18049e";
export const COLOR_HEADER_FI_LEADERBOARD = "#58e4a5";
export const COLOR_HEADER_DAILY_SALES = "#049e0e";
export const COLOR_HEADER_LEADERBOARD = "#ff0303";
export const COLOR_HEADER_CIT = "#635f7c";
export const COLOR_HEADER_COMMISSION_PAYROLL = "#ecd903";
export const COLOR_HEADER_COMMISSION_DRILLDOWN = "#689e04";
export const COLOR_HEADER_OTB_GM_MTD_ENTRY = COLOR_HARLEY_ORANGE;
export const COLOR_HEADER_OTB_GM_BATCH_ENTRY = COLOR_HARLEY_ORANGE;
export const COLOR_HEADER_OTB_GM_CATEGORY = COLOR_HARLEY_ORANGE;
export const COLOR_HEADER_OTB_GM_RECAP = COLOR_HARLEY_ORANGE;
export const COLOR_HEADER_OTB_GM_GROUP = COLOR_HARLEY_ORANGE;
export const COLOR_HEADER_OTB_GM_SUMMARY = COLOR_HARLEY_ORANGE;

export const COLOR_FONT_DEFAULT = "#000000";
export const COLOR_HEADER_FONT_DEFAULT = "#FFFFFF";

export const COLOR_HEADER_FONT_HOME = COLOR_HARLEY_BLACK;
export const COLOR_HEADER_FONT_VS_ENTRY = "#FFFFFF";
export const COLOR_HEADER_FONT_VS_MGR_REPORT = "#FFFFFF";
export const COLOR_HEADER_FONT_VS_GP_DETAILS = "#FFFFFF";
export const COLOR_HEADER_FONT_VS_LEADERBOARD = "#FFFFFF";
export const COLOR_HEADER_FONT_FI_LEADERBOARD = "#FFFFFF";
export const COLOR_HEADER_FONT_DAILY_SALES = "#FFFFFF";
export const COLOR_HEADER_FONT_LEADERBOARD = "#FFFFFF";
export const COLOR_HEADER_FONT_CIT = "#FFFFFF";
export const COLOR_HEADER_FONT_COMMISSION_PAYROLL = "#FFFFFF";
export const COLOR_HEADER_FONT_COMMISSION_DRILLDOWN = "#FFFFFF";
export const COLOR_HEADER_FONT_OTB_GM_MTD_ENTRY = "#FFFFFF";
export const COLOR_HEADER_FONT_OTB_GM_BATCH_ENTRY = "#FFFFFF";
export const COLOR_HEADER_FONT_OTB_GM_CATEGORY = "#FFFFFF";
export const COLOR_HEADER_FONT_OTB_GM_RECAP = "#FFFFFF";
export const COLOR_HEADER_FONT_OTB_GM_GROUP = "#FFFFFF";
export const COLOR_HEADER_FONT_OTB_GM_SUMMARY = "#FFFFFF";


export const SHEET_NAME_HOME = "Radar Home";
export const SHEET_NAME_VS_ENTRY = "VS, Unit Entry";
export const SHEET_NAME_VS_MGR_REPORT = "VS, Mgr Report";
export const SHEET_NAME_VS_GP_DETAILS = "VS, GP Details";
export const SHEET_NAME_VS_LEADERBOARD = "VS, Leaderboard";
export const SHEET_NAME_FI_LEADERBOARD = "FI Leaderboard"; 
export const SHEET_NAME_DAILY_SALES = "Daily Sales Update";
export const SHEET_NAME_LEADERBOARD = "Sales Leaderboard";
export const SHEET_NAME_CIT = "Contracts In Transit";
export const SHEET_NAME_COMMISSION_PAYROLL = "Commission Payroll";
export const SHEET_NAME_COMMISSION_DRILLDOWN = "Commission Drilldown";
export const SHEET_NAME_OTB_GM_MTD_ENTRY = "GM MTD Data Entry";
export const SHEET_NAME_OTB_GM_BATCH_ENTRY = "GM Batch Entry";
export const SHEET_NAME_OTB_GM_RECAP = "GM DEFCON Recap";
export const SHEET_NAME_OTB_GM_CATEGORY = "GM OTB Category";
export const SHEET_NAME_OTB_GM_GROUP = "GM OTB Group";
export const SHEET_NAME_OTB_GM_SUMMARY = "GM OTB Summary";

export const SHEET_HEADER_HOME = "Welcome to DECON Radar 3.0 - Your home away from home";
export const SHEET_HEADER_VS_ENTRY = "Vehicle Sales Entry";
export const SHEET_HEADER_VS_MGR_REPORT = "Vehicle Sales Manager Report";
export const SHEET_HEADER_VS_GP_DETAILS = "Vehicle Sales GP Details";
export const SHEET_HEADER_VS_LEADERBOARD = "Vehicle Sales Leaderboard";
export const SHEET_HEADER_FI_LEADERBOARD = "Finance & Insurance Leaderboard";
export const SHEET_HEADER_DAILY_SALES = "Daily Sales Update";
export const SHEET_HEADER_LEADERBOARD = "Daily Sales Leaderboard";
export const SHEET_HEADER_CIT = "Contracts In Transit";
export const SHEET_HEADER_COMMISSION_PAYROLL = "Vehicle Sales Commission Payroll";
export const SHEET_HEADER_COMMISSION_DRILLDOWN = "Vehicle Sales Commission Drilldown";
export const SHEET_HEADER_OTB_GM_MTD_ENTRY = "GM MTD Data Entry";
export const SHEET_HEADER_OTB_GM_BATCH_ENTRY = "GM Batch Entry";
export const SHEET_HEADER_OTB_GM_CATEGORY = "GM DEFCON Category";
export const SHEET_HEADER_OTB_GM_RECAP = "GM DEFCON Recap";
export const SHEET_HEADER_OTB_GM_GROUP = "GM DEFCON Group";
export const SHEET_HEADER_OTB_GM_SUMMARY = "GM OTB Summary";

// Hidden sheets
export const SHEET_NAME_HIDDEN_OTB_GM_BATCH_ENTRY = "hidden_gm_batch_entry"; // Used to track which cells have or haven't been changed upon saving - removes superfluous update queries

export const OTB_DISPLAY_FIELD_FUTURE_ORDER_EXPECTED = "Future Order Expected Delivery"; // field = future_order_expected        format = Acct
export const OTB_DISPLAY_FIELD_PROJECTED_INCREASE = "Projected Increase"; // field = projected_increase       format = Percent
export const OTB_DISPLAY_FIELD_PROJECTED_MARGIN = "Projected Margin"; // field = projected_margin     format = Percent
export const OTB_DISPLAY_FIELD_PROJECTED_TURNS = "Projected Turns"; // field = projected_turns      format = Number
export const OTB_DISPLAY_FIELD_PROJECTED_SALES_OVERRIDE = "Projected Sales Override"; // field = projected_sales_override     format = Acct
export const OTB_DISPLAY_FIELD_PROJECTED_COGS_OVERRIDE = "Projected COGS Override"; // field = projected_cogs_override      format = Acct

export const OTB_FIELD_FUTURE_ORDER_EXPECTED = "future_order_expected";
export const OTB_FIELD_PROJECTED_INCREASE = "projected_increase";
export const OTB_FIELD_PROJECTED_MARGIN = "projected_margin";
export const OTB_FIELD_PROJECTED_TURNS = "projected_turns";
export const OTB_FIELD_PROJECTED_SALES_OVERRIDE = "projected_sales_override";
export const OTB_FIELD_PROJECTED_COGS_OVERRIDE = "projected_cogs_override";

export const UM_SELECT_USER_TEXT = "Select User";

export const CURRENCY_FORMAT = `_($* #,##0.00_);_($* (#,##0.00);_($* "-"??_);_(@_)`; // Excel currency-format regex
export const CURRENCY_FORMAT_ROUNDED = `_($* #,##0_);_($* (#,##0.00);_($* "-"??_);_(@_)`; // Excel currency-format regex - closest dollar

export const PERCENT_FORMAT = `0%`; // Excel percent-format regex
export const NUMBER_FORMAT = `#,##0`; // Excel number-format regex

export const UID_WHEN_LOGGED_OUT = 'loggedout';

export const NAV_UM = 1001;
export const NAV_EM = 1002;
export const NAV_VS_ENTRY = 1003;
export const NAV_VS_ENTRY_ADD = 1004;
export const NAV_VS_MGR = 1005;
export const NAV_VS_GPD = 1006;
export const NAV_VS_LEADERBOARD = 1007;
export const NAV_FI_LEADERBOARD = 1008;
export const NAV_DAILY_SALES = 1009;
export const NAV_DAILY_SALES_LEADERBOARD = 1010;
export const NAV_CIT = 1011;
export const NAV_COM_PAYROLL = 1012;
export const NAV_COM_DRILLDOWN = 1013;
export const NAV_LOGIN = 1014;
export const NAV_OTB_GM_MTD = 1015;
export const NAV_OTB_GM_BATCH = 1016;
export const NAV_OTB_GM_RECAP = 1017;
export const NAV_OTB_GM_CAT = 1018;
export const NAV_OTB_GM_GROUP = 1019;
export const NAV_OTB_GM_SUMMARY = 1020;
export const NAV_DASHBOARD = 1021;

export const DASHBOARD_GREETINGS = [
     "Welcome to the DEFCON 3 Dashboard"
    , "Breathe Easier with DEFCON 3"
    , "Your Sales, Simplified with DEFCON 3"
    , "DEFCON 3: Your Sales Ally"
    , "Navigate Your Sales with DEFCON 3"
    , "You're in. The rest is up to you."
    , "Another day, another set of opportunities."
    , "All systems normal. Let's find something interesting."
    , "Your sales data is live and waiting."
    , "Back again? The numbers missed you."
    , "Ready when you are. The data never sleeps."
    , "Time to check what moved, what didn't, and why."
    , "Dashboard's up. Coffee optional, curiosity required."
    , "Let's see where things stand."
    , "Your data, fresh and accounted for."
    , "Another login, another chance to outperform yesterday."
    , "The numbers are in. Interpret responsibly."
    , "Your daily reality check has arrived."
    , "All caught up? Let's dive in anyway."
    , "Numbers are live. Expectations are negotiable."
    , "Your sales story continues—let's read the next chapter."
    , "Login successful. Great decisions loading…"
    , "New day, same goals, slightly better execution?"
    , "The data's fresh. Your move."
    , "Welcome back—let's move some iron."
    , "Chrome shines brighter when it's sold."
    , "Time to turn browsers into riders."
    , "Throttle up—those numbers won't chase themselves."
    , "Fuel the pipeline. Close the ride."
    , "Less talk, more torque."
    , "Today's forecast: accountability with a chance of results."
    , "Let's make the scoreboard worth looking at."
    , "Data's ready—now comes the hard part."
    , "Welcome back—let's keep the wheels turning."
    , "Diagnostics ready. Coffee recommended."
    , "The bikes are waiting. They always are."
    , "Less downtime, more ride time."
]
